export class Sheet {
  id: number
  grade: number
  room_name: string
  curriculum_id: number
  subject_name: string
  name: string
  student_count: number
  answer_image_completed: boolean
  test_start_datetime_at: string
  grace_time: string
  limit_time: string
  schedule_setting_completed: boolean
  is_exists_test_started_examinees: boolean
  test_start_datetime_at_cache: string
  grace_time_cache: string
  limit_time_cache: string

  constructor(sheet: any){
    this.id = sheet.id;
    this.grade = sheet.grade;
    this.room_name = sheet.room_name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.name = sheet.name;
    this.student_count = sheet.student_count;
    this.answer_image_completed = this.answer_image_completed;
    this.test_start_datetime_at = sheet.test_start_datetime_at;
    this.grace_time = sheet.grace_time;
    this.limit_time = sheet.limit_time;
    this.schedule_setting_completed = sheet.schedule_setting_completed;
    this.is_exists_test_started_examinees = sheet.is_exists_test_started_examinees;
    this.test_start_datetime_at_cache = sheet.test_start_datetime_at;
    this.grace_time_cache = sheet.grace_time;
    this.limit_time_cache = sheet.limit_time;
  }
}

export class ReflectCondition {
  test_start_datetime_at: string = ""
  grace_time: string = ""
  limit_time: string = ""
}